<template>
  <div class="cr-page">
    <SnackbarComp :SnackbarComponent="snackbar" />

    <AddCallersDialog
      v-model="showAddDialog"
      :caller="selectedCaller"
      :mode="dialogMode"
      @saved="handleSaved"
    />

    <BulkAddCallersDialog
      v-model="showBulkUploadDialog"
      @saved="handleSaved"
    />

    <DeleteCallerDialog
      v-model="showDeleteDialog"
      :caller="selectedCaller"
      @deleted="handleSaved"
    />

    <CallerProfileDrawer
      v-model="showProfileDrawer"
      :caller="selectedCaller"
      @edit="openEdit"
      @delete="openDelete"
    />

    <div class="cr-panel">
      <div class="cr-panel__toolbar">
        <div class="cr-panel__toolbar-start">
          <span class="cr-panel__count">{{ totalCallers }} caller{{ totalCallers === 1 ? '' : 's' }}</span>
        </div>
        <CallersHeader
          :total-callers="totalCallers"
          :total-calls="totalCalls"
          :loading="loading"
          :is-session-ready="isSessionReady"
          :is-search-active="isSearchActive"
          @add="openCreate"
          @refresh="handleRefresh"
          @bulk-upload="showBulkUploadDialog = true"
        />
      </div>

      <CallersList
        :callers="paginatedCallers"
        :loading="loading"
        :is-search-active="isSearchActive"
        @view="openView"
        @edit="openEdit"
        @delete="openDelete"
      />

      <PortalListPagination
        class="cr-panel__footer"
        :page="page"
        :page-count="pageCount"
        :items-per-page="itemsPerPage"
        :range-label="rangeLabel"
        :total="filteredCallers.length"
        @update:page="setPage"
        @update:items-per-page="setItemsPerPage"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import SnackbarComp from '@/components/Extras/SnackbarComp.vue'
import PortalListPagination from '@/components/Extras/PortalListPagination.vue'
import AddCallersDialog from '@/components/Callers/Dialogs/AddCallersDialog.vue'
import BulkAddCallersDialog from '@/components/Callers/Dialogs/BulkAddCallersDialog.vue'
import DeleteCallerDialog from '@/components/Callers/Dialogs/DeleteCallerDialog.vue'
import CallerProfileDrawer from '@/components/Callers/CallerProfileDrawer.vue'
import CallersHeader from '@/components/Callers/CallersHeader.vue'
import CallersList from '@/components/Callers/CallersList.vue'
import {
  useCallersData,
  getCallersErrorMessage,
} from '@/composables/callers/useCallersData'

defineOptions({ name: 'CallersPage' })

const snackbar = ref({})
const showAddDialog = ref(false)
const showBulkUploadDialog = ref(false)
const showDeleteDialog = ref(false)
const showProfileDrawer = ref(false)
const selectedCaller = ref(null)
const dialogMode = ref('CREATE')

const {
  loading,
  page,
  itemsPerPage,
  pageCount,
  isSessionReady,
  filteredCallers,
  paginatedCallers,
  totalCallers,
  totalCalls,
  rangeLabel,
  isSearchActive,
  loadCallers,
  setPage,
  setItemsPerPage,
} = useCallersData()

function showError(payload) {
  snackbar.value = {
    SnackbarVmodel: true,
    SnackbarColor: 'error',
    SnackbarText: getCallersErrorMessage(payload),
  }
}

async function handleRefresh() {
  try {
    const result = await loadCallers()
    if (result && result.status === 'ERROR') {
      showError(result)
    }
  } catch (err) {
    showError(err)
  }
}

function handleSaved() {
  showProfileDrawer.value = false
  loadCallers()
}

function openCreate() {
  selectedCaller.value = null
  dialogMode.value = 'CREATE'
  showAddDialog.value = true
}

function openView(caller) {
  selectedCaller.value = { ...caller }
  showProfileDrawer.value = true
}

function openEdit(caller) {
  selectedCaller.value = { ...caller }
  dialogMode.value = 'EDIT'
  showProfileDrawer.value = false
  showAddDialog.value = true
}

function openDelete(caller) {
  selectedCaller.value = { ...caller }
  showProfileDrawer.value = false
  showDeleteDialog.value = true
}
</script>
